import { combineReducers, Reducer } from 'redux';
import { ItemsReducer } from './ItemsReducer';
import { IContentBySearchState } from '..';
import { QueryReducer } from './QueryReducer';
import { StatusReducer } from './StatusReducer';
import { PaginationReducer } from './PaginationReducer';
import { EnvReducer } from './EnvReducer';

export const rootReducer = combineReducers<IContentBySearchState>({
  items: ItemsReducer,
  query: QueryReducer,
  status: StatusReducer,
  pagination: PaginationReducer,
  env: EnvReducer
});
